import Settings from '@/services/api/adminSettings.js';

export default {
  namespaced: true,
  state: {
    mails: [],
    mail: {},
  },
  getters: {
    mails: state => state.mails,
    mail: state => state.mail,
  },
  mutations: {
    setMails: (state, mails) => {
      state.mails = mails;
    },
    setMail: (state, mail) => {
      state.mail = mail;
    },
  },
  actions: {
    getTempCodeMail (state) {
      return new Promise((resolve, reject) => {
        Settings.getTempCodeMail()
          .then(({ data }) => {
            state.commit('setMails', data.data);
          })
          .catch(e => reject(e));
      });
    },

    addTempCodeMail (state, { mail }) {
      return new Promise((resolve, reject) => {
        Settings.addTempCodeMail(mail)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },

    deleteTempCodeMail (state, id) {
      return new Promise((resolve, reject) => {
        Settings.deleteTempCodeMail(id)
          .then((response) => {
            resolve(response);
            state.dispatch('getTempCodeMail');
          })
          .catch(e => reject(e));
      });
    },
  },
};
